import React, { useState } from 'react';

const EmpresaForm = ({ onCreate }) => {
  const [nombre, setNombre] = useState('');
  const [rfc, setRfc] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (nombre && rfc) {
      onCreate({ nombre, rfc });
    }
  };

  return (
    <div className="container">
      <h2 className="titulo">Registrar Empresa</h2>
      <form onSubmit={handleSubmit}>
        <input
          className="input"
          type="text"
          placeholder="Nombre de la empresa"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
        />
        <input
          className="input"
          type="text"
          placeholder="RFC"
          value={rfc}
          onChange={(e) => setRfc(e.target.value)}
        />
        <button className="boton" type="submit">
          Crear Empresa
        </button>
      </form>
    </div>
  );
};

export default EmpresaForm;